import { useEffect } from "react";
import { AgGridReact } from "ag-grid-react";

interface UseTableSortProps {
  gridRef: React.RefObject<AgGridReact>;
  sort?: string;
  order?: "ASC" | "DESC";
  isReady?: boolean;
}

/**
 * 테이블 정렬 상태를 URL 파라미터와 동기화하는 커스텀 훅
 * @param props 정렬 설정에 필요한 속성들
 */
const useTableSort = ({ gridRef, sort, order, isReady }: UseTableSortProps) => {
  useEffect(() => {
    if (gridRef.current && sort && order && isReady) {
      const columnApi = gridRef.current.columnApi;
      if (columnApi) {
        // 모든 컬럼의 정렬 상태 초기화
        columnApi.applyColumnState({
          defaultState: { sort: null },
        });

        // URL에서 가져온 정렬 상태 적용
        columnApi.applyColumnState({
          state: [
            {
              colId: sort,
              sort: order.toLowerCase() as "asc" | "desc",
            },
          ],
          defaultState: { sort: null },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridRef.current, sort, order, isReady]);
};

export default useTableSort;
